import { isMinimumQuotaLimitType } from 'data/quotaLimitTypes';

/**
 * Answer quota modes. A question is in exactly one at a time.
 * NONE: no answer quotas. MAX: per-answer ceilings. MIN: per-answer floors.
 */
export const QUOTA_MODE = {
  NONE: 'none',
  MAX: 'max',
  MIN: 'min',
};

/**
 * Derive answer quota mode from simple-quota presence plus quotaLimitType.
 * With quotas present, an absent limit type is max.
 */
export const deriveQuotaMode = ({
  simpleQuotasPresent = false,
  quotaLimitType,
} = {}) => {
  if (!simpleQuotasPresent) {
    return QUOTA_MODE.NONE;
  }

  return isMinimumQuotaLimitType(quotaLimitType)
    ? QUOTA_MODE.MIN
    : QUOTA_MODE.MAX;
};

/**
 * Map a switch's boolean `enabled` to a mode: on → `activeMode`, off → NONE.
 */
export const quotaModeFromEnabled = (enabled, activeMode) =>
  enabled ? activeMode : QUOTA_MODE.NONE;
